import { render, staticRenderFns } from "./UnifiedMenuCustom.vue?vue&type=template&id=4df9fd36&"
import script from "./UnifiedMenuCustom.vue?vue&type=script&lang=js&"
export * from "./UnifiedMenuCustom.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedMenuCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports